import chatListContactsRedux from '../../modals/chatListContacts/redux/slice'
import chatChannelListRedux from '../../modals/chatChannelList/redux/slice'
import chatMessageListRedux from '../../modals/chatMessageList/redux/slice'

export default {
    chatListContactsRedux,
    chatChannelListRedux,
    chatMessageListRedux
};